import AbstractShape from "@/Models/Shapes/AbstractShape";
import { PreviewShapeFactory } from "@/Models/Shapes/PreviewShapeFactory";
import ShapeConfigurationFactory from "@/Models/ShapeConfigurations/ShapeConfigurationFactory";
import { convertUnits } from "@/functions/numbers";

export default {
	namespaced: true,
	getters: {
		getInstance: ( state, getters, rootState, { measurements } ): AbstractShape => {
			return ( new PreviewShapeFactory() ).get( {
				shape: 'right-angled-triangle-mirrored',
				dimensions: measurements.dimensions,
				modifiers: measurements.modifiers,
			} );
		},
		cutoutPrimitives: ( state, getters, rootState, { cutoutMeasurements } ): object => {
			return convertUnits( cutoutMeasurements.dimensions[ 'right-angled-triangle-mirrored' ] );
		},
		getCutoutArea: ( state, getters, rootState, { cutoutMeasurements, getArea } ): number => {
			return getArea( 'right-angled-triangle-mirrored', cutoutMeasurements.dimensions[ 'right-angled-triangle-mirrored' ] );
		},
		isCenteredShape: (): boolean => false,
		getArea: ( state, getters, rootState, { getArea, parsedDimensions } ): object => {
			return getArea( 'right-angled-triangle-mirrored', parsedDimensions );
		}
	},
};
